import { useCallback, useMemo, useState } from 'react';
import { isLowScoreFormValid } from '../utils/feedback-utils';

// Local answers for the low-score form: selected reason slots, follow-up answers
// (by rendered question position) and the comment.
export const useLowScoreAnswers = (lowScore) => {
  const [reasons, setReasons] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [comment, setComment] = useState('');

  const toggleReason = useCallback((slot) => {
    setReasons((prev) => (prev.includes(slot) ? prev.filter((item) => item !== slot) : [...prev, slot]));
  }, []);

  const setAnswer = useCallback((index, value) => {
    setAnswers((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  }, []);

  const values = useMemo(() => ({ reasons, answers, comment }), [reasons, answers, comment]);

  return {
    values,
    isValid: isLowScoreFormValid(lowScore, values),
    toggleReason,
    setAnswer,
    setComment,
  };
};
